import { FormInputText, Text } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

// Keeps the input visually disabled while allowing the end adornment to remain clickable
export const ConfirmedEmailInput = styled(FormInputText)`
  .MuiInputAdornment-positionEnd {
    pointer-events: auto;
  }
`;

export const SsoSubtitle = styled(Text)`
  margin-bottom: 20px;
`;

export const EmailLabel = styled(Text)`
  display: block;
  margin-bottom: 4px;
  text-align: left;
`;

export const SsoProviderButton = styled.button`
  width: 360px;
  height: 44px;
  border: 1px solid #dadada;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 12px;
  border-radius: 25px;
  margin-top: 10px;

  &:hover {
    background: #f5f5f5;
  }

  @media (max-width: 380px) {
    width: 250px;
  }
`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #9e9e9e;
  font-size: 12px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid #dadada;
  }
`;

export const BackToLoginRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 20px;
  svg {
    color: ${colorTokens.text.dark};
  }
  a {
    color: ${colorTokens.text.dark};
  }
`;
